/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_error__contact_us = /** @type {(inputs: {}) => string} */ () => {
	return `uns kontaktieren`
};

const en_error__contact_us = /** @type {(inputs: {}) => string} */ () => {
	return `contact us`
};

const es_error__contact_us = /** @type {(inputs: {}) => string} */ () => {
	return `ponerte en contacto con nosotros`
};

const fr_error__contact_us = /** @type {(inputs: {}) => string} */ () => {
	return `nous contacter`
};

const it_error__contact_us = /** @type {(inputs: {}) => string} */ () => {
	return `contattarci`
};

const nl_error__contact_us = /** @type {(inputs: {}) => string} */ () => {
	return `neem contact met ons op`
};

const pt_error__contact_us = /** @type {(inputs: {}) => string} */ () => {
	return `contacte-nos`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const error__contact_us = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.error__contact_us(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("error__contact_us", locale)
	if (locale === "de") return de_error__contact_us(inputs)
	if (locale === "en") return en_error__contact_us(inputs)
	if (locale === "es") return es_error__contact_us(inputs)
	if (locale === "fr") return fr_error__contact_us(inputs)
	if (locale === "it") return it_error__contact_us(inputs)
	if (locale === "nl") return nl_error__contact_us(inputs)
	return pt_error__contact_us(inputs)
};